import React from 'react'

import { FormattedMessage } from 'react-intl'
import { Link, useLocation } from 'react-router-dom'

import { ButtonWithIcon } from './Buttons'
import { RightArrowIcon } from './svgIcons'

type CustomLinkProps = React.ComponentProps<typeof Link> & {
  className?: string
}

const CustomLink = React.forwardRef<HTMLAnchorElement, CustomLinkProps>(({ children, className, ...props }, ref) => {
  const location = useLocation()
  return (
    <Link ref={ref} className={className} {...props} state={{ previousPath: location.pathname }}>
      {children}
    </Link>
  )
})
CustomLink.displayName = 'CustomLink'

interface JumpToDetailsLinkButtonProps {
  children: StringOrMessage
  detailsUrl: string
}

export function JumpToDetailsLinkButton({ children, detailsUrl }: JumpToDetailsLinkButtonProps) {
  return (
    <ButtonWithIcon
      forwardedAs={CustomLink}
      icon={<RightArrowIcon />}
      size="small"
      to={detailsUrl}
      variant="secondaryContained"
    >
      {children}
    </ButtonWithIcon>
  )
}

export function JumpToInvoiceDetailsLinkButton({ detailsUrl }: Pick<JumpToDetailsLinkButtonProps, 'detailsUrl'>) {
  return (
    <JumpToDetailsLinkButton detailsUrl={detailsUrl}>
      <FormattedMessage id="document.preview.linkToInvoiceDetails" defaultMessage="Ugrás a számlarészletekhez" />
    </JumpToDetailsLinkButton>
  )
}
